/* eslint-disable max-len */
/**
 * Awvent - Products API
 * Awvent Products Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';

import { Observable }                                        from 'rxjs';
import { environment }                                        from '../../../../../environments/environment';

import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { ProductCreateCommand } from '../model/productCreateCommand';
import { ProductDtoListWebApiPagedResponse } from '../model/productDtoListWebApiPagedResponse';
import { ProductDtoWebApiResponse } from '../model/productDtoWebApiResponse';
import { ProductUpdateCommand } from '../model/productUpdateCommand';
import { AudienceDto } from '../model/audienceDto';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';

@Injectable()
export class ProductService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.products;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productActivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoWebApiResponse>;
    public productActivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoWebApiResponse>>;
    public productActivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoWebApiResponse>>;
    public productActivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling productActivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productActivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProductDtoWebApiResponse>('put',`${this.basePath}/Product/Activate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productDeactivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoWebApiResponse>;
    public productDeactivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoWebApiResponse>>;
    public productDeactivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoWebApiResponse>>;
    public productDeactivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling productDeactivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productDeactivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProductDtoWebApiResponse>('put',`${this.basePath}/Product/Deactivate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoListWebApiPagedResponse>;
    public productGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoListWebApiPagedResponse>>;
    public productGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoListWebApiPagedResponse>>;
    public productGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProductDtoListWebApiPagedResponse>('get',`${this.basePath}/Product`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public productIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public productIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public productIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling productIdDelete.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/Product/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoWebApiResponse>;
    public productIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoWebApiResponse>>;
    public productIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoWebApiResponse>>;
    public productIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling productIdGet.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productIdGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProductDtoWebApiResponse>('get',`${this.basePath}/Product/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productPost(xTenantId: string, body?: ProductCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoWebApiResponse>;
    public productPost(xTenantId: string, body?: ProductCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoWebApiResponse>>;
    public productPost(xTenantId: string, body?: ProductCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoWebApiResponse>>;
    public productPost(xTenantId: string, body?: ProductCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productPost.');
        }



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProductDtoWebApiResponse>('post',`${this.basePath}/Product`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public productPut(xTenantId: string, body?: ProductUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<ProductDtoWebApiResponse>;
    public productPut(xTenantId: string, body?: ProductUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProductDtoWebApiResponse>>;
    public productPut(xTenantId: string, body?: ProductUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProductDtoWebApiResponse>>;
    public productPut(xTenantId: string, body?: ProductUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling productPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProductDtoWebApiResponse>('put',`${this.basePath}/Product`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    // GAP-BACKEND-ADMIN-004 — PATCH /api/v1/Product/{id}/Audience (Share modal).
    public productSetAudience(id: string, xTenantId: string, audience: AudienceDto): Observable<ProductDtoWebApiResponse> {
        let headers = this.defaultHeaders.set('x-tenant-id', String(xTenantId)).set('Content-Type', 'application/json');
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        const accept = this.configuration.selectHeaderAccept(['application/json', 'text/json', 'text/plain']);
        if (accept !== undefined) {
            headers = headers.set('Accept', accept);
        }
        return this.httpClient.request<ProductDtoWebApiResponse>(
            'patch',
            `${this.basePath}/Product/${encodeURIComponent(id)}/Audience`,
            { body: audience, withCredentials: this.configuration.withCredentials, headers }
        );
    }
}
